import { PlatzBlobViewTokensItem, PlatzTokenView } from "../api-generated";
import {
  isNewLineToken,
  isNumberToken,
  isPunctuationToken,
  isSpaceToken,
  isTabToken,
  isWordToken,
} from "./discriminatorsAndThings";

export function getTokenString(token: PlatzTokenView): string {
  if (
    isWordToken(token) ||
    isNumberToken(token) ||
    isPunctuationToken(token) ||
    isTabToken(token)
  ) {
    return token.valueAsString;
  }

  if (isSpaceToken(token) || isNewLineToken(token)) {
    //don't print new lines in this function
    return " ";
  }

  const exhaustiveCheck: never = token;
  throw new Error(`Unhandled token type: ${exhaustiveCheck}`);
}

export function getTokenListString(tokens: PlatzBlobViewTokensItem[]): string {
  return tokens.map(getTokenString).join("");
}
